import { select, take } from "redux-saga/effects";
import { ReduxActionTypes } from "legacy/constants/ReduxActionConstants";
import {
  getHasEvaluated,
  getIsEvaluating,
} from "legacy/selectors/evaluatorSelectors";

export function* waitForNextEvaluationToComplete() {
  const isEvaluating: boolean = yield select(getIsEvaluating);
  if (isEvaluating) {
    yield take(ReduxActionTypes.START_EVALUATE_TREE);
  }
  yield take(ReduxActionTypes.SET_EVALUATED_TREE);
}

export function* waitForFirstEvaluation() {
  const hasFirstEval: boolean = yield select(getHasEvaluated);
  if (!hasFirstEval) {
    yield take(ReduxActionTypes.SET_EVALUATED_TREE);
  }
}
